import script from "./Comments.vue?vue&type=script&setup=true&lang=js"
export * from "./Comments.vue?vue&type=script&setup=true&lang=js"

import "./Comments.vue?vue&type=style&index=0&id=d78ceebe&scoped=true&lang=css"
import "./Comments.vue?vue&type=style&index=1&id=d78ceebe&lang=less"

import exportComponent from "E:\\Workspaces\\成品油\\成品油_基础版\\成品油溯源码（扫码）\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d78ceebe"]])

export default __exports__